module.exports = __webpack_public_path__ + "media/stylesheets/images/boxil/BOXIL SaaS AWARD Summer 2024_料金の妥当性No.1-4323b61fe91ec6165d99d0d4917e62d2.png";